import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 12 10" {...props}>
    <path
      fillRule="evenodd"
      d="M5.284 9.594a.816.816 0 0 0 .588-.345L11.1 1.648c.12-.192.161-.398.12-.623a.75.75 0 0 0-.345-.517c-.188-.12-.398-.162-.619-.12a.75.75 0 0 0-.517.345L5.08 7.52 2.216 4.756a.9.9 0 0 0-.386-.262.761.761 0 0 0-.458-.019.88.88 0 0 0-.405.233.744.744 0 0 0-.213.416.903.903 0 0 0 .041.469c.052.15.15.27.285.367l3.559 3.416c.161.15.352.225.57.225h.075v-.007Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgCheckMark;
